<template>
  <div id="app">
    <loading ref="loading"/>
    <notifications group="foo" position="bottom right" width="500"/>
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"/>
    </transition>
    <AccessibilityToolbar />
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Loading from './Loading'
import i18n from '~/plugins/i18n'
import store from '~/store'
import AccessibilityToolbar from 'vue-accessibility-toolbar'

// Load layout components dynamically.
const requireContext = require.context('~/layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component.default || component
    return components
  }, {})

export default {
  el: '#app',

  components: {
    Loading,
    AccessibilityToolbar
  },

  data: () => ({
    layout: null,
    defaultLayout: 'default'
  }),

  async beforeCreate () {
    // Preload data.
    await this.$store.dispatch('evaluations/fetchEvaluations')
    await this.$store.dispatch('isco/fetchISCO')
    await this.$store.dispatch('roles/fetchRoles')
    await this.$store.dispatch('languages/fetchLanguages')
    await this.$store.dispatch('professionallevels/fetchProfessionallevels')
    await this.$store.dispatch('scholarlevels/fetchScholarlevels')
    await this.$store.dispatch('satisfactionperceptions/fetchSatisfactionperceptions')
    await this.$store.dispatch('nationalities/fetchNationalities')
  },

  metaInfo () {
    return {
      title: this.$t(window.config.appName)
    }
  },

  mounted () {
    this.$loading = this.$refs.loading
  },

  methods: {
    /**
    * Set the application layout.
    *
    * @param {String} layout
    */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    }
  }
}
</script>

<style>
  .vue-notification {
    font-size: 20px;

    &.success {
     background: #509d62;
     border-left-color: #4fda83;
   }
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/App.vue